export const EKycStatus = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  INIT: 'init',
} as const;
export type TKycStatus = (typeof EKycStatus)[keyof typeof EKycStatus];

export const EKycResult = {
  GREEN: 'GREEN',
  RED: 'RED',
  YELLOW: 'YELLOW',
} as const;
export type TKycResult = (typeof EKycResult)[keyof typeof EKycResult];
